import React, { useEffect, useState, useRef } from 'react';
import "./index.scss";


import RightArrow from "../../../assets/images/scan-info/right-arrow-black.svg";

const PaginationArrow = ({ totalCount, currentPage = 1, onPageChange }) => {
    const [pageValue, setPageValue] = useState(currentPage);
    const [totalPages, setTotalPages] = useState(1);

    // Ref for the input field
    const inputRef = useRef(null);

    // Updates total pages based on totalCount
    useEffect(() => {
        setTotalPages(Math.ceil(totalCount / 10));
    }, [totalCount]);

    // Validates the page number and triggers the parent callback
    const triggerPageChange = (value) => {
        let newPage = Math.max(1, Math.min(value, totalPages)); // Ensure the page is in range
        setPageValue(newPage);
        onPageChange && onPageChange(newPage); // Trigger the callback if provided
    };

    // Handles the Enter key press
    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            triggerPageChange(Number(e.target.value));
            inputRef.current?.blur(); // Blurs the input field
        }
    };

    // Handles input validation for numbers only
    const handleInputChange = (e) => {
        const value = e.target.value;
        if (/^\d*$/.test(value)) { // Regex to allow only numbers
            setPageValue(value ? Number(value) : ""); // Empty string for temporary blank input
        }
    };

    return (
        <div className="py-5 list-pagination d-flex align-items-center justify-content-between">
            {/* Previous Section */}
            <div>
                <button className="page-button" disabled={pageValue <= 1} onClick={() => triggerPageChange(1)}>
                    <img src={RightArrow} alt="arrow-right" />
                    <img src={RightArrow} alt="arrow-right" />
                </button>
                <button className="page-button" disabled={pageValue <= 1} onClick={() => triggerPageChange(currentPage - 1)}>
                    <img src={RightArrow} alt="arrow-right" />
                </button>
            </div>

            {/* Input Section */}
            <div className="page-input">
                <input
                    ref={inputRef} // Assign input reference
                    type="text"
                    value={pageValue}
                    onChange={handleInputChange}
                    onKeyDown={handleKeyPress} // Handle key press
                    onBlur={() => triggerPageChange(pageValue)} // Trigger change on blur
                /> 
                / {totalPages}
            </div>

            {/* Next Section */}
            <div>
                <button
                    className="page-button arrow-right"
                    disabled={pageValue >= totalPages}
                    onClick={() => triggerPageChange(pageValue + 1)}
                >
                    <img src={RightArrow} alt="arrow-right" />
                </button>
                <button
                    className="page-button arrow-right"
                    disabled={pageValue >= totalPages}
                    onClick={() => triggerPageChange(totalPages)}
                >
                    <img src={RightArrow} alt="arrow-right" />
                    <img src={RightArrow} alt="arrow-right" />
                </button>
            </div>
        </div>
    );
};

export default PaginationArrow;